import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=d89d3982"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=d89d3982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports